import { LogData } from "@/entities/history/types";
import { createUseFilteredEntitiesInfinite } from "@/services/api/infinite";
import { EmptyFilters, Filters } from "@/services/api/types";
import useBoundStore, {
  MAX_ENTITIES_PER_PAGE
} from "@/services/store/BoundStore";

export const MAX_LOGS_PER_PAGE = MAX_ENTITIES_PER_PAGE;

export const {
  useFilteredEntitiesInfinite,
  useResetFilteredEntitiesInfinite: useResetFilteredHistory
} = createUseFilteredEntitiesInfinite<LogData, Filters>(
  "history",
  MAX_LOGS_PER_PAGE
);

export const useFilteredHistory = (
  filters: Filters = EmptyFilters,
  pageSize = MAX_LOGS_PER_PAGE,
  sortField?: string,
  sortAsc?: boolean,
  fetchAll = false,
  enabled = true
) => {
  return useFilteredEntitiesInfinite(
    () => ({ addEntity: useBoundStore((state) => state.history.addEntity) }),
    {
      filters,
      pageSize,
      sortField,
      sortAsc,
      fetchAll,
      enabled
    }
  );
};
